import * as MenuIcon from "assets/desktop/icons/menu";

import { GameList, gameList } from "./game-list";
import { PATH } from "./path";

export interface MenuItemType {
  title: string;
  path: string;
  icon: string;
  categoryCode: string;
  isGame: boolean;
  isSubGame?: boolean;
}
export const menuList: MenuItemType[] = [
  {
    title: "Trang chủ",
    path: PATH.Home,
    icon: MenuIcon.home,
    categoryCode: "",
    isGame: false,
  },
  ...(gameList.map((item: GameList) => ({
    title: item.categoryName,
    path: `/${item.categoryId}`,
    icon: item.icon,
    categoryCode: item.categoryCode,
    isGame: true,
    isSubGame: item.isSubGame,
  })) as MenuItemType[]),
  {
    title: "Khuyến mãi",
    path: PATH.Promotion,
    icon: MenuIcon.promo,
    categoryCode: "",
    isGame: false,
  },
  {
    title: "VIP CLUB",
    path: PATH.User.MemberVip,
    icon: MenuIcon.vip,
    categoryCode: "",
    isGame: false,
  },
  {
    title: "Đại lý",
    path: "https://acv188.com/agent-page/",
    icon: MenuIcon.daily,
    categoryCode: "daily",
    isGame: false,
  },
  {
    title: "Live Bóng",
    path: "#",
    icon: MenuIcon.live,
    categoryCode: "live",
    isGame: false,
  },
];
